import React from 'react';
import PropTypes from 'prop-types';

import TeXHTMLString from './TeXHTMLString';

const TeXHTML = (props) => {
  const { content, configText, imagePreviewVisible, setImagePreviewVisible, blockIndex } = props;

  return (
    <div className="texblockbodywrap">
      <TeXHTMLString
        imagePreviewVisible={imagePreviewVisible}
        setImagePreviewVisible={setImagePreviewVisible}
        content={content}
        configText={configText}
        props={props}
        blockIndex={blockIndex}
      />
    </div>
  );
};

TeXHTML.propTypes = {
  content: PropTypes.oneOfType([PropTypes.number, PropTypes.string]).isRequired,
  configText: PropTypes.instanceOf(Object).isRequired,
  imagePreviewVisible: PropTypes.bool.isRequired,
  setImagePreviewVisible: PropTypes.func.isRequired,
  blockIndex: PropTypes.string,
};

export default TeXHTML;
